module.exports = __webpack_public_path__ + "static/media/ambassadors.e28d7559.webp";